<template>
  <div>
    <v-container>
      <v-row align="start">
        <v-col>
          <v-card class="pa-5" elevation="5">
            <v-container class="mb-4">
              <v-text-field v-model="search" append-icon="mdi-magnify" label="Search" single-line
                hide-details></v-text-field>
            </v-container>
            <v-data-table :group-by="groupBy" :headers="headers" :items="files" :items-per-page="-1" :search="search">
              <template v-slot:group-header="{
                item,
                columns,
                toggleGroup,
                isGroupOpen,
              }">
                <template :ref="(el) => { groupHeader[item.value] = { item, toggleGroup, isGroupOpen } }" />
                <tr>
                  <td :colspan="columns.length">
                    <div class="d-flex align-center">
                      <v-btn :icon="isGroupOpen(item) ? '$expand' : '$next'" color="primary" density="comfortable"
                        size="small" variant="outlined" @click="toggleGroup(item)"></v-btn>
                      <span class="ms-4">Category: {{ item.value }}</span>
                    </div>
                  </td>
                </tr>
              </template>
              <template v-slot:[`item.action`]="{ item }">
                <v-icon color="primary" size="large" @click="sendFile(item.RowKey)">mdi-send</v-icon>
              </template>
            </v-data-table>
          </v-card>
        </v-col>
      </v-row>
      <status-dialog :isStatusDialog="showStatus" :isLoad="isMailProcess" :text="mailStatus"
        @close="closeDialog"></status-dialog>
    </v-container>
    <user-info-dialog :isNoUserInfo="isNoUserInfo" @close="closeUserInfoDialog" @save="saveUserInfo"></user-info-dialog>
  </div>
</template>

<script>
import { ref } from 'vue';
import StatusDialog from './StatusDialog.vue';
import UserInfoDialog from "./UserInfoDialog.vue";

export default {
  name: "FilesTable",
  components: {
    StatusDialog,
    UserInfoDialog,
  },
  data: () => ({
    search: "",
    groupHeader: ref([]),
    groupBy: [{ key: "Type", order: "asc" }],
    headers: [
      { title: "IC", key: "IC" },
      { title: "Type", key: "DocType" },
      { title: "Revision", key: "Revision" },
      { title: "Description", key: "Description" },
      { title: "Document Name", key: "RowKey" },
      { title: "Get File", key: "action", align: "center", sortable: false },
    ],
    mailStatus: "The file is being sent to your email",
    showStatus: false,
    isMailProcess: false,
    isNoUserInfo: false,
  }),
  computed: {
    files() {
      return this.$store.getters["file/filesList"];
    },
  },
  async mounted() {
    const urlParams = new URLSearchParams(window.location.search);
    var fileName = urlParams.get("file");
    var fileDes = urlParams.get("des");

    if (fileName != null) {
      this.search = fileName;
      this.openGroup();
      await this.sendFile(fileName, null);
    } else if (fileDes != null) {
      await this.sendFile(null, fileDes);
      this.search = this.$store.getters["file/respFileName"];
      this.openGroup();
    }

    if (this.mailStatus == "The file has been successfully sent to your email.") {
      const url = new URL(window.location.href);
      url.searchParams.delete("file");
      url.searchParams.delete("des");
      url.searchParams.delete("type");
      window.history.replaceState({}, '', url.toString());
    }
  },
  methods: {
    openGroup() {
      try {
        const groupName = this.files.find(file => file.RowKey == this.search).Type;
        Object.values(this.groupHeader).forEach(header => {
          if (header.item.value == groupName && !header.isGroupOpen(header)) {
            header.toggleGroup(header.item);
          }
        });
      } catch {
        //
      }
    },
    async sendFile(file, des) {
      this.mailStatus = "The file is being sent to your email";
      this.showStatus = true;
      this.isMailProcess = true;
      try {
        await this.$store.dispatch("file/sendFileLink", file != null ? {
          fileName: file,
        } : { fileDes: des });
        this.mailStatus = this.$store.getters["file/mailStatus"];
        if (this.mailStatus == "No User Info") {
          this.isNoUserInfo = true;
          this.showStatus = false;
        }
      } catch (err) {
        this.mailStatus = "Something went wrong!";
      }
      this.isMailProcess = false;

      setTimeout(() => {
        this.showStatus = false;
      }, 5000);
    },
    async saveUserInfo(givenName, surname, organization) {
      try {
        await this.$store.dispatch("user/updateUserInfo", {
          givenName: givenName,
          surname: surname,
          organization: organization,
        });
        if (this.$store.getters["user/status"] == "Success") {
          this.mailStatus = "Update success, please request file again";
          this.showStatus = true;
        } else {
          this.mailStatus = "Something went wrong!";
          this.showStatus = true;
        }
      } catch (err) {
        this.mailStatus = "Something went wrong!";
        this.showStatus = true;
      }
      this.isNoUserInfo = false;
    },
    closeDialog() {
      this.showStatus = false;
    },
    closeUserInfoDialog() {
      this.isNoUserInfo = false;
    },
  },
};
</script>